module.exports = __webpack_public_path__ + "static/media/gcdef_10037.13aac30d.ico";